import { NotchDevice } from './privateTypes';

const devicesWithDynamicIsland: NotchDevice[] = [
  {
    brand: 'Apple',
    model: 'iPhone 14 Pro',
  },
  {
    brand: 'Apple',
    model: 'iPhone 14 Pro Max',
  },
];

export default devicesWithDynamicIsland;
